import { render } from "./ExhibitorDetailDialog.vue?vue&type=template&id=652e6417&scoped=true&ts=true"
import script from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"

import "./ExhibitorDetailDialog.vue?vue&type=style&index=0&id=652e6417&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652e6417"]])

export default __exports__